import React from 'react';
import { BadgeStyle as S } from './Badge.style';
import * as iconsLibrary from '../Icon/icons.library';
import { borderRadius, colourPalette } from 'styles/styles';
import { Icon } from 'components/Icon/Icon';
import { useClassNames } from 'hooks/useClassNames';
import { Text, TextProps } from 'components/Text/Text';
import { Box } from 'components/layouts/primitives/Box/Box';

export type BadgeProps = {
  label: string;
  radius?: keyof typeof borderRadius;
  iconLeft?: keyof typeof iconsLibrary;
  iconRight?: keyof typeof iconsLibrary;
  bgColor?: keyof typeof colourPalette;
  color?: keyof typeof colourPalette;
  bgColorAlpha?: number;
  onClick?: () => void;
  className?: string;
  testId?: string;
  title?: TextProps['title'];
  ellipsis?: TextProps['ellipsis'];
  wordBreak?: TextProps['wordBreak'];
};

export const Badge: React.FC<BadgeProps> = ({
  iconLeft,
  iconRight,
  label,
  bgColor,
  color,
  bgColorAlpha,
  radius,
  className,
  testId,
  ellipsis,
  wordBreak,
  onClick,
  title,
}) => {
  const containerClassNames = useClassNames(
    {
      'badge-container': true,
    },
    className
  );

  return (
    <S.Container
      $bgColor={bgColor}
      $bgColorAlpha={bgColorAlpha}
      $isClickable={!!onClick}
      $radius={radius}
      onClick={onClick}
      className={containerClassNames}
    >
      {!!iconLeft && (
        <Box fit="content">
          <Icon className="block" icon={iconLeft} color={color} size={16} />
        </Box>
      )}
      {!!label && (
        <Text
          as="span"
          size="fontSizeXS"
          weight="medium"
          color={color || 'neutral600'}
          className="badge-label"
          testId={testId}
          ellipsis={ellipsis}
          wordBreak={wordBreak}
          title={title}
        >
          {label}
        </Text>
      )}
      {!!iconRight && (
        <Box fit="content">
          <Icon className="block" icon={iconRight} color={color} size={16} />
        </Box>
      )}
    </S.Container>
  );
};
